module.exports = __webpack_public_path__ + "img/php.be7b6e28.png";